

import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { URLS } from 'src/app/constants/URLS';
import { Router } from '@angular/router';
import { DownloadProgressService } from 'src/app/_service/download-progress.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';


declare let shaka: any | undefined;
declare var window: any | undefined;


@Component({
  selector: 'app-downloadlist',
  templateUrl: './downloadlist.component.html',
  styleUrls: ['./downloadlist.component.css']
})
export class DownloadlistComponent implements OnInit {
  watchHistory: any[];
  isLoading:boolean = false;
  removingVideo:boolean = false;
  donwloadData = [];
  ccPrimeVideos:any[] = [];
  primeVideos:any[] = [];
  firstVideo:any;
  @ViewChild('video') video: ElementRef | undefined;
  
  constructor(
    public router: Router,
    private downloadProgressService: DownloadProgressService,
    private mycontentservice: MycontentserviceService,
    private sanitizer: DomSanitizer,
    private whitelabelService: WhiteLabelService,
    private ngZone: NgZone,
    private device: IosBridgeService
    ) { 
      window.addEventListener('nativeDownloadsLoaded', (event: any) => {
        console.log('📥 download list received from iOS:', event.detail);
        this.ngZone.run(() => {
          const list = event?.detail ?? [];
          this.donwloadData = list.map(v => ({
            ...v,
            thumbnailUrl: v?.localThumbnailPath ? `local://thumb/${v.localThumbnailPath}` : './assets/img/thumbnail.png'
          }));
          this.isLoading = false;
          console.log('📥 Final iOS download list:', this.donwloadData);
        });
      });
      window.addEventListener('videoDeleted', (event: any) => {
        console.log(event);
        const deletedId = event.detail?.vidLibId || event.detail?.videoId;
        this.ngZone.run(() => {
          this.donwloadData = this.donwloadData.filter(v => v.videoId != deletedId);
          this.isLoading = false;
        });
        console.log("🗑 iOS Confirmed Delete:", deletedId);
      });
    }

  ngOnInit(): void {
    this.isLoading = true;
    if (this.device.isIOS()) {
      console.log("📲 iOS detected → requesting download list...");
      this.device.requestDownloadList();  
      return;
    }  
    this.prepareDownloadData(); 
  }    

  async prepareDownloadData() {
    this.isLoading = true;
    this.primeVideos = [];
    this.ccPrimeVideos = [];
    this.donwloadData = []; 
    try {
      const content = await this.getStorageContentWithRetry();

      if (!content || content.length === 0) {
        console.warn('No content found in storage.');
        this.isLoading = false;
        return;
      }

      const currentDate = new Date();
      const expiryDays = 30;
      let expiredVideosCount = 0; 

      for (let videoEle of content) {
        const downloadedDate = new Date(videoEle.appMetadata.downloaded);
        console.log(downloadedDate);
        const expiryDate = new Date(downloadedDate);
        expiryDate.setDate(downloadedDate.getDate() + expiryDays);
        console.log(expiryDate, currentDate);

        if(expiryDate < currentDate){
          console.warn(`Video expired and removed: ${videoEle.title}`);
          await this.removeFromDB(videoEle);
          expiredVideosCount++;
          continue;
        }

        if (videoEle?.appMetadata?.thumbnail instanceof Blob) {
          videoEle.appMetadata.downloadBlob = URL.createObjectURL(videoEle?.appMetadata?.thumbnail);
        } else {
          console.warn('Invalid or missing thumbnail for:', videoEle);
          videoEle.appMetadata.downloadBlob = './assets/img/thumbnail.png';
        }
        if (!videoEle.thumbnailUrl) {
          videoEle.thumbnailUrl = videoEle?.appMetadata?.downloadBlob;
        }
        if (videoEle.appMetadata) {
          const offlineUri = videoEle.offlineUri;
          videoEle.preparedVideoType = this.prepareVideoType(videoEle.appMetadata);
          videoEle.vidLibId = videoEle.appMetadata.vidLibId;
          videoEle = { ...videoEle, ...videoEle.appMetadata, offlineUri };
        } else {
          console.warn('appMetadata is missing for video:', videoEle);
        }
        if (videoEle.thumbnailUrl && !videoEle.thumbnailUrl.includes(this.downloadProgressService.currentDownloadVideoId)) {
          this.donwloadData.push(videoEle); 
        }
      }
      console.log('Final Download Data:', this.donwloadData);
      this.firstVideo = this.getFirstVideo();
      this.mycontentservice.downloadListData = this.donwloadData;
      this.mycontentservice.downloadedCount = this.donwloadData.length;
      this.isLoading = false;
  
    } catch (error) {
      console.error('Error in prepareDownloadData:', error);
    }
  }
  
  async getStorageContentWithRetry(retries = 3, delay = 500): Promise<any[]> {
    let content;
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        content = await window.storage?.list();
        if (content && content.length > 0) {
          return content;
        }
      } catch (error) {
        console.error('Error fetching from storage on attempt', attempt + 1, error);
      }
      await this.delay(delay);
    }
    return [];
  }
  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  ngOnDestroy() {
    if(!this.device.isIOS()){
      this.donwloadData.forEach(video => {
        if (video.appMetadata.downloadBlob) {
          URL.revokeObjectURL(video.appMetadata.downloadBlob);
        }
      });
    }
  }  

  onErrorEvent(event) {
    this.onError(event.detail);
  }
  
  onError(error) {
    console.error('Error code', error.code, 'object', error);
  }

  getWatchListContents(){
    var userId = localStorage.getItem("userId");
    this.mycontentservice.getWatchListOfUser(userId).subscribe(result2 => {  
      this.donwloadData = result2
    });
  }

  stopPropagation(event:MouseEvent){
    event.stopPropagation();
  }

  sanitizeBlobUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  
  prepareVideoType(category) {
    if(category.isFreeVideo) {
      return 'FREE';
    } else if((category.sub_value && category.sub_value != '0')){
      return category.sub_value;
    } else if((category.unSub_value && category.unSub_value != '0')){
      return category.unSub_value;
    } else {
      return 'Sub';
    }
  }

  getFirstVideo() {
    if (this.ccPrimeVideos.length > 0) {
      return this.ccPrimeVideos[0];
    } else {
      return null;
    }
  }

  navigateToPlayer(video: any){
    if(video?.appMetadata){
      localStorage.setItem('item', JSON.stringify(video));
    }
    console.log(video);
    if(video?.series_id){
      const route = this.whitelabelService.getPrefixedRoute('shows', video.series_id, video.title, video.vidLibId, 'watch');
      this.router.navigate([route], {
        queryParams: { offlineUri: video?.offlineUri }
      });
    }else{
      const route = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId, 'watch');
      this.router.navigate([route], {
        queryParams: { offlineUri: video?.offlineUri }
      });
    }
  }

  openVideoPlayer(video: any) {
    if(this.device.isIOS()){
      const route = this.whitelabelService.getPrefixedRoute('movies', video.title, video?.videoId, 'watch');
      const payload = {
        video: video,
        returnRoute: this.router.url,
        playerUrl: `${this.device.getCurrentDomain()}${route}?aspect=${video?.tqrVideoBean?.mediaLayout}`,
      };
      this.device.openVideoPlayer(payload);
      return;
    }
    if(video.videoCategory === 'ccPrime'){
      const route = this.whitelabelService.getPrefixedRoute('watch');
      this.router.navigate([route], {
        queryParams: { offlineUri: video?.offlineUri }
      });
    }else if(video.videoCategory === 'Prime'){
      this.navigateToPlayer(video);
    }
  }

  sortDownloadedList() {
    this.donwloadData = this.donwloadData.sort( (a, b) =>{
      return new Date(b.downloaded).getTime() - new Date(a.downloaded).getTime();
    })
  }

  async removeFromDB(video){
    if(this.device.isIOS()){
      this.isLoading = true;
      this.device.send('deleteVideo', video);
    }else{
      this.donwloadData = this.donwloadData.filter(v => v.offlineUri != video.offlineUri);
      console.log(this.donwloadData);
      try{
        if(video.offlineUri){
          if(video.drmSession){
            await this.closeDRMSession(video.drmSession);
            console.log(`DRM session closed for video: ${video.title}`);
          }
          if(window.storage){
            await window.storage.remove(video.offlineUri);
            console.log(`Removed video: ${video.title}`);
          }
        }else{
          console.warn('No offlineUri found for video:', video);
        }
      }catch(error){
        console.error('Error while removing expired videos', error);
      }
    }
  }

  async closeDRMSession(drmSession){
    try{
      if(drmSession){
        await drmSession.close();
        console.log('DRM session closed.');
      }else{
        console.log('No DRM session to close');
      }
    } catch (error){
      console.error('Failed to close DRM session;', error);
    }
  }
  
  async removeFromList(video: any, index: number) {
    this.downloadProgressService.currentDownloadVideoId = video.vidLibId;
    this.downloadProgressService.isDownloadInprogress = true;
    try {
      if (window.storage) {
        await window.storage.remove(video.offlineUri);
        console.log(`Removed video: ${video.title}`);
      }
      this.donwloadData.splice(index, 1);
    } catch (error) {
      console.error('Error while removing video:', error);
    }
  }  

  formatDuration(duration: any): string {
    if (!duration) return '0:00';
    if (typeof duration === 'string' && duration.includes(':')) {
      const parts = duration.split(':').map(Number);
      if (parts.length === 3) { 
        const [h, m, s] = parts;
        return h > 0 ? `${h}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}` : `${m}:${s.toString().padStart(2,'0')}`;
      }
      if (parts.length === 2) return duration; 
    }
    if (typeof duration === 'number') {
      const h = Math.floor(duration / 3600);
      const m = Math.floor((duration % 3600) / 60);
      const s = Math.floor(duration % 60);
      return h > 0 ? `${h}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}` : `${m}:${s.toString().padStart(2,'0')}`;
    }
    return '0:00';
  }
  
  formatViews(views: number): string {
    if (views >= 1000000) {
      return (views / 1000000).toFixed(1) + 'M';
    } else if (views >= 1000) {
      return (views / 1000).toFixed(1) + 'K';
    }
    return views?.toString() || '0';
  }

  formatTimeAgo(date: string): string {
    if (!date) return '';
    const now = new Date();
    const videoDate = new Date(date);
    const diffTime = Math.abs(now.getTime() - videoDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 30) return `${diffDays} days ago`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
    return `${Math.floor(diffDays / 365)} years ago`;
  }
}